import React, { useState } from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 9px;
`;

const Label = styled.label`
  font-size: 16px;
  font-weight: 500;
  box-sizing: border-box;
  color: rgba(0, 0, 0, 0.9);
  font-family: 'Montserrat';

  @media (max-width: 1200px) {
    font-size: 10px;
  }
`;

const ProgressBarWrapper = styled.div`
  position: relative;
  height: 6px;
  background-color: #FFFFFF;
  border-radius: 3px;
  border: 1px solid rgba(171, 154, 144, 0.5);
  box-sizing: border-box;

  @media (max-width: 1200px) {
      height: 4px;
  }
`;

const Slider = styled.input.attrs({ type: 'range' })`
  width: 100px;
  appearance: none;
  background: transparent;
  position: relative;
  z-index: 2;
  box-sizing: border-box;

  &::-webkit-slider-thumb {
    appearance: none;
    height: 20px;
    width: 20px;
    border-radius: 50%;
    background: rgba(171, 154, 144, 1);
    cursor: pointer;
    margin-top: -16px;
    border: none;
  }

  &::-moz-range-thumb {
    height: 20px;
    width: 20px;
    border-radius: 50%;
    background: rgba(171, 154, 144, 1);
    cursor: pointer;
    border: none;
  }

  &::-webkit-slider-runnable-track {
    height: 6px;
    background: transparent;
  }

  &::-moz-range-track {
    height: 6px;
    background: transparent;
  }

  @media (max-width: 1200px) {
      width: 60px;

      &::-webkit-slider-thumb {
       margin-top: -6px;
      }

      &::-moz-range-thumb {
        width: 8px;
        height: 8px;
      }

      &::-webkit-slider-thumb {
        width: 8px;
        height: 8px;
      }
  }
`;

const NumberInput = styled.input.attrs({ type: 'number' })`
  width: 80px;
  height: 39px;
  border-radius: 10px;
  opacity: 1;
  border: 1px solid #AB9A9080;
  padding: 5px;
  font-size: 14px;
  text-align: center;
  box-sizing: border-box;
  color: rgba(0, 0, 0, 0.9);
  font-family: 'Montserrat';


  @media (max-width: 1200px) {
    width: 40px;
    height: 26px;
    font-size: 8px;

  }
`;

const SliderWithInput = ({ label, min = 0, max = 100, step = 1, onChange }) => {
  const [value, setValue] = useState(0);

  const handleSliderChange = (e) => {
    setValue(Number(e.target.value));
    onChange(Number(e.target.value))
  };

  const handleInputChange = (e) => {
    const newValue = Number(e.target.value);
    if (newValue >= min && newValue <= max) {
      setValue(newValue);
      onChange(newValue)
    }
  };

  return (
    <Wrapper>
      <Label>{label}</Label>
      <ProgressBarWrapper>
        <Slider
          min={min}
          max={max}
          step={step}
          value={value}
          onChange={handleSliderChange}
        />
      </ProgressBarWrapper>
      <NumberInput
        min={min}
        max={max}
        step={step}
        value={value}
        onChange={handleInputChange}
      />
    </Wrapper>
  );
};

export default SliderWithInput;